import { SignerMessage, WithdrawSigners } from '../types.ds';

const ADMIN_ADDRESS = process.env.REACT_APP_ADMIN_PUB_KEY;
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const generateWithDrawSigners = async (
  id: string,
  walletAddress: string,
  amount: number
) => {
  if (!id || !walletAddress || !amount || !API_ENDPOINT) {
    throw new Error('Invalid userId, walletAddress or withdrawl amount.');
  }
  try {
    const req = await fetch(`${API_ENDPOINT}/post/withdrawSigner`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        userId: id,
        walletAddress: walletAddress,
        amount: amount,
      }),
    });
    if (req.status === 200) {
      const res: WithdrawSigners = await req.json();
      return res;
    }

    return null;
  } catch (error) {
    throw new Error('Failed to generate signers.');
  }
};
